<template>
  <div class="image-popup" :style="overlayBgStyle" @click="$emit('closeScroll')">
    <div class="close-button">
      <q-btn icon="close" flat round dense @click="$emit('closeScroll')" />
      <ReturnHomeButton @click="$emit('closeAllDialogs')" />

    </div>
    <div class="image-popup-container">
      <div class="image-popup-item" v-for="(image, i) in resources" :key="image.index || i">
        <img class="img" loading="lazy" :src="image.url" :style="{ transform: image.rotation ? `rotate(${image.rotation}deg)` : 'none' }" />
      </div>
    </div>
  </div>
</template>
  
<script>
import { ref, onMounted } from 'vue';
import axios from "axios";
import Tiff from 'tiff.js';
import ReturnHomeButton from './ReturnHomeButton.vue';
import { useOverlayBg } from '../composables/useOverlayBg';

export default {
  components: { ReturnHomeButton },
  props: ['blockScrollDatas'],
  setup(props) {
    let resources = ref([]);
    
    const start = () => {
      fetchResources();
    };

    const fetchResources = async () => {
      try {
        if (props.blockScrollDatas) {
          let resourcesTemp = [];
          
          for (let i = 0; i < props.blockScrollDatas.associatedResources.length; i++) {
            const resource = props.blockScrollDatas.associatedResources[i];
            const url = `${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`;
            let response = await axios.get(url);

            if (resource.name.endsWith('.tif') || resource.name.endsWith('.tif')) {
              // Charger et convertir le fichier TIFF
              const tiffUrl = await convertTiff(response.data);
              resourcesTemp.push({
                url: tiffUrl,
                rotation: getRotationAngle(resource.name),
                index: resource.index !== undefined ? Number(resource.index) : i // S'assurer que l'index est un nombre
              });
            } else {
              // Pour les autres formats d'image
              resourcesTemp.push({
                url: response.data,
                rotation: getRotationAngle(resource.name),
                index: resource.index !== undefined ? Number(resource.index) : i // S'assurer que l'index est un nombre
              });
            }
          }
          
          // Log avant le tri
          console.log('Avant tri:', resourcesTemp.map(r => ({ index: r.index, name: r.url.split('/').pop() })));
          
          // Trier les ressources par index
          resourcesTemp.sort((a, b) => a.index - b.index);
          
          // Log après le tri
          console.log('Après tri:', resourcesTemp.map(r => ({ index: r.index, name: r.url.split('/').pop() })));
          
          // Assigner les ressources triées
          resources.value = resourcesTemp;
        }
      } catch (error) {
        console.error(error);
      }
    };

    const convertTiff = async (tiffUrl) => {
      try {
        const response = await axios.get(tiffUrl, { responseType: 'arraybuffer' });
        
        // Vérification du type MIME
        const mimeType = response.headers['content-type'];
        console.log('MIME type:', mimeType);
        
        // Vérification des premiers octets du fichier
        const buffer = response.data;
        const magicNumber = new Uint8Array(buffer.slice(0, 4));
        console.log('Magic number:', magicNumber);

        const tiffImage = new Tiff({ buffer });
        const canvas = tiffImage.toCanvas();
        return canvas.toDataURL('image/png'); // Retourner l'URL au lieu de l'ajouter directement
      } catch (error) {
        console.error('Erreur lors de la conversion du fichier TIFF:', error);
        return ''; // Retourner une chaîne vide en cas d'erreur
      }
    }

    const getRotationAngle = (name) => {
      if (name.includes("IMG_20230227_164954")) {
        return -90;
      } else if (name.includes("IMG_20230227_164729")) {
        return 180;
      } else if (name.includes("IMG_20230227_163631")) {
        return 180;
      }
      return null;
    };

    onMounted(start);

    const { overlayBgStyle } = useOverlayBg();

    return {
      overlayBgStyle,
      resources,
      getRotationAngle
    };
  },
};
</script>
  
<style scoped>
.image-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(217, 217, 217, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.image-popup-container {
  width: 70%;
  max-height: 90vh;
  overflow-y: scroll;
  display: flex;
  gap: 90px;
  flex-direction: column;
  align-items: center;
}

.image-popup-item {
  margin: 10px 0;
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img {
  max-width: 100vw;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 2px solid #f0f0f0;
}

.image-popup-item img {
  max-width: 80%;
  max-height: 100%;
  object-fit: contain;
}
</style>
  
